export const addSpacesEveryThreeDigits = (number) => {
  const numberString = number.toString();
  const regex = /\B(?=(\d{3})+(?!\d))/g;

  return numberString.replace(regex, ' ');
}